/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    RealizedReportTradeDto,
    RealizedReportTradeDtoFromJSON,
    RealizedReportTradeDtoFromJSONTyped,
    RealizedReportTradeDtoToJSON,
} from './RealizedReportTradeDto';
import {
    SymbolDividendDto,
    SymbolDividendDtoFromJSON,
    SymbolDividendDtoFromJSONTyped,
    SymbolDividendDtoToJSON,
} from './SymbolDividendDto';
import {
    UnrealizedReportTradeDto,
    UnrealizedReportTradeDtoFromJSON,
    UnrealizedReportTradeDtoFromJSONTyped,
    UnrealizedReportTradeDtoToJSON,
} from './UnrealizedReportTradeDto';

/**
 * 
 * @export
 * @interface BrokerSectionDto
 */
export interface BrokerSectionDto {
    /**
     * 
     * @type {string}
     * @memberof BrokerSectionDto
     */
    brokerName: string | null;
    /**
     * 
     * @type {Array<RealizedReportTradeDto>}
     * @memberof BrokerSectionDto
     */
    realizedReportTrades: Array<RealizedReportTradeDto>;
    /**
     * 
     * @type {Array<UnrealizedReportTradeDto>}
     * @memberof BrokerSectionDto
     */
    unrealizedReportTrades: Array<UnrealizedReportTradeDto>;
    /**
     * 
     * @type {Array<SymbolDividendDto>}
     * @memberof BrokerSectionDto
     */
    dividends: Array<SymbolDividendDto>;
}

export function BrokerSectionDtoFromJSON(json: any): BrokerSectionDto {
    return BrokerSectionDtoFromJSONTyped(json, false);
}

export function BrokerSectionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BrokerSectionDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'brokerName': json['brokerName'],
        'realizedReportTrades': ((json['realizedReportTrades'] as Array<any>).map(RealizedReportTradeDtoFromJSON)),
        'unrealizedReportTrades': ((json['unrealizedReportTrades'] as Array<any>).map(UnrealizedReportTradeDtoFromJSON)),
        'dividends': ((json['dividends'] as Array<any>).map(SymbolDividendDtoFromJSON)),
    };
}

export function BrokerSectionDtoToJSON(value?: BrokerSectionDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'brokerName': value.brokerName,
        'realizedReportTrades': ((value.realizedReportTrades as Array<any>).map(RealizedReportTradeDtoToJSON)),
        'unrealizedReportTrades': ((value.unrealizedReportTrades as Array<any>).map(UnrealizedReportTradeDtoToJSON)),
        'dividends': ((value.dividends as Array<any>).map(SymbolDividendDtoToJSON)),
    };
}

